<script>
    import Login from './Login.svelte';
    import Modal from './Modal.svelte';
    import TSApp from './TSApp.svelte';
    import TSAppEdit from './TSAppEdit.svelte';
    import TSAppLogs from './TSAppLogs.svelte';
    import Devices from './Devices.svelte';
    import Members from './Members.svelte';
    import apps from './stores/AppStore.js';
    let modal = {show: false, content: {tag: ''}};

    const appEvents = (e) => {
        modal.content = e.detail;
        modal.show = true;
    }
    const modalEvents = async (e) => {
        if(e.detail.tag == 'close') return modal.show = false;
    }
    const appEditEvents = (e) => {
        if(e.detail.tag === 'close') return modal.show = false;
        if(e.detail.tag === 'app-created') {
            modal.show = false;
            modal.content = e.detail;
            setTimeout(() => {
                modal.show = true; 
            }, 1500);
        }
    }
    const newApp= (appType) => {
        modal.content.tag = 'settings';
        modal.content.app = {title: '', description: '', type: appType};
        modal.show = true;
    }
</script>

<Login/>

<div class="mb-4">
    <button class="button is-small mb-2 mr-2 is-success is-outlined" on:click={() => newApp('Map')}>Map Service <i class="ml-2 fas fa-circle-plus"></i></button>
    <button class="button is-small mb-2 mr-2 is-success is-outlined" on:click={() => newApp('Smart Environments')}>Smart Environments <i class="ml-2 fas fa-circle-plus"></i></button>
</div>

<div class="columns is-multiline">
    {#await apps.getAll()} 
        <!-- <p>Fetching apps...</p> -->
    {:then}
        {#each $apps as app }
            <TSApp {app} on:elementAction={appEvents} on:elementAction></TSApp>
        {/each}
    {:catch error}
        <p>{error}</p>
    {/await}
</div>

{#if modal.content.tag === 'settings' && modal.show}
    <Modal show={modal.show} on:elementAction={modalEvents}>
        <span slot="title">{modal.content.app.title}</span>
        <div slot="content">
            <p><span class="tag is-light mb-2">{modal.content.app.type}</span></p>
            <TSAppEdit app={modal.content.app} on:elementAction={appEditEvents}/>
        </div>
    </Modal>
{/if}

{#if modal.content.tag === 'logs' && modal.show}
    <Modal show={modal.show} on:elementAction={modalEvents}>
        <span slot="title">{modal.content.app.title}</span>
        <div slot="content">
            <p><span class="tag is-light mb-2">{modal.content.app.type}</span></p>
            <TSAppLogs app={modal.content.app} on:elementAction={appEditEvents}/>
        </div>
    </Modal>
{/if}

{#if modal.content.tag === 'members' && modal.show}
    <Modal show={modal.show} on:elementAction={modalEvents}>
        <span slot="title">{modal.content.app.title}</span>
        <div slot="content"><Members app={modal.content.app} on:elementAction={appEditEvents}/></div>
    </Modal>
{/if}

{#if modal.content.tag === 'devices' && modal.show}
    <Modal show={modal.show} on:elementAction={modalEvents}>
        <span slot="title">{modal.content.app.title}</span>
        <div slot="content"><Devices app={modal.content.app} on:elementAction={appEditEvents}/></div>
    </Modal>
{/if}

{#if modal.content.tag === 'app-created' && modal.show}
    <Modal show={modal.show} on:elementAction={modalEvents}>
        <span slot="title">{modal.content.app.title}</span>
        <div slot="content">
            <div class="has-background-warning is-size-7 is-rounded mb-6 p-4">
                <p><i>Please copy this information and store it in a secure place.</i></p>
            </div>
            <div class="mb-6">
                <p>The client id and api key below will let you access our API from a third party application.</p>
                <pre>Client Id: <strong>{modal.content.app.clientId}</strong></pre>
                <pre>API Key: <strong>{modal.content.app.apiKey}</strong></pre>
            </div>
            <button class="button is-info" on:click={ () => navigator.clipboard.writeText(
                `Client Id: ${modal.content.app.clientId}\nAPI Key: ${modal.content.app.apiKey}`
            )}>Copy to clipboard</button>
        </div>
    </Modal>
{/if}

